import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumKegstarContainerType implements BaseEnumType {
  private static allValues: EnumKegstarContainerType[] = []; // make sure this is top-most
  
  public static none = new EnumKegstarContainerType(0, "None", "enum_kegstar_container_type_none");
  public static kegstarKeg50L = new EnumKegstarContainerType(1, "KegstarKeg50L", "enum_kegstar_container_type_kegstar_keg50_l");
  public static kegstarKeg30L = new EnumKegstarContainerType(2, "KegstarKeg30L", "enum_kegstar_container_type_kegstar_keg30_l");
  public static kegstarKeg20L = new EnumKegstarContainerType(3, "KegstarKeg20L", "enum_kegstar_container_type_kegstar_keg20_l");
  public static kegstarCask9G = new EnumKegstarContainerType(4, "KegstarCask9G", "enum_kegstar_container_type_kegstar_cask9_g");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumKegstarContainerType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumKegstarContainerType.none; }
  public isKegstarKeg50L() { return this === EnumKegstarContainerType.kegstarKeg50L; }
  public isKegstarKeg30L() { return this === EnumKegstarContainerType.kegstarKeg30L; }
  public isKegstarKeg20L() { return this === EnumKegstarContainerType.kegstarKeg20L; }
  public isKegstarCask9G() { return this === EnumKegstarContainerType.kegstarCask9G; }

  public static getValues(): readonly EnumKegstarContainerType[] {
    return EnumKegstarContainerType.allValues;
  }

  public static getValuesExcept0(): readonly EnumKegstarContainerType[] {
    return EnumKegstarContainerType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumKegstarContainerType {
    const found = EnumKegstarContainerType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumKegstarContainerType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumKegstarContainerType): EnumKegstarContainerType {
    const found = name ? EnumKegstarContainerType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumKegstarContainerType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumKegstarContainerType>): boolean {
    return this.key === other?.key;
  }
}